<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18"><rect width="17" height="17" x=".5" y=".5" fill="#000" rx="3.5"/><rect width="17" height="17" x=".5" y=".5" stroke="#000" rx="3.5"/><path stroke="#fff" stroke-width="2" d="m4.63 9.25 3.262 2.717 5.434-6.521"/></svg>
</template>

<script>
  export default {
    name: "CheckMarkBlack"
  }
</script>

<style scoped>

</style>